import { Sidebar } from '@/components/dashboard/Sidebar'
import { DashboardPropertyContextProvider } from '@/context/dashboardproperty.context'
import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router'
import { motion } from 'framer-motion'

export const Route = createFileRoute('/_protected/dashboard')({
  component: RouteComponent
})

function RouteComponent() {
  return (
    <DashboardPropertyContextProvider>
      <DashboardLayout />
    </DashboardPropertyContextProvider>
  )
}

function DashboardLayout() {
  const { location } = useRouterState();
  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      <Sidebar />
      <main className="flex-1 flex flex-col overflow-y-auto">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col flex-1 w-full max-w-7xl mx-auto p-2 md:p-6 lg:p-8"
        >
          <Outlet />
        </motion.div>
      </main>
    </div>
  );
}